export default [
  { key: 'primary_processor_reference', val: 'Processor Reference:' },
];
